import React from 'react';
import { motion } from 'framer-motion';
import ProjectCard from '../components/ProjectCard';

const comedyProjects = [
  {
    title: 'Stand-up Special: "Everyday Absurdity"',
    description: 'A 45-minute stand-up comedy special exploring the bizarre moments of everyday life through observational humor.',
    image: 'https://via.placeholder.com/600x400?text=Stand-up+Special',
    creator: 'Matthew' as const,
    tags: ['Stand-up', 'Live Performance', 'Observational'],
    link: '#'
  },
  {
    title: 'Sketch Comedy Series: "The Odd Hours"',
    description: 'A collection of sketch comedy pieces inspired by late-night infomercials and the strange world of midnight television.',
    image: 'https://via.placeholder.com/600x400?text=Sketch+Comedy',
    creator: 'Both' as const,
    tags: ['Sketch Comedy', 'Character Work', 'Satire'],
    link: '#'
  },
  {
    title: 'Improv Troupe: "The Maybe\'s"',
    description: 'Highlights from a year of performing with an experimental improv comedy group focusing on long-form narrative.',
    image: 'https://via.placeholder.com/600x400?text=Improv',
    creator: 'Roscoe' as const,
    tags: ['Improv', 'Live Performance', 'Ensemble'],
    link: '#'
  },
  {
    title: 'Comedy Writing: "The Peculiar Times"',
    description: 'A satirical newsletter in the style of The Onion, covering fictional events from a small, eccentric town.',
    image: 'https://via.placeholder.com/600x400?text=Comedy+Writing',
    creator: 'Matthew' as const,
    tags: ['Writing', 'Satire', 'Publication'],
    link: '#'
  },
  {
    title: 'Character Comedy: "The Many Faces"',
    description: 'A showcase of original comedy characters with elaborate backstories and unique perspectives on the world.',
    image: 'https://via.placeholder.com/600x400?text=Character+Comedy',
    creator: 'Both' as const,
    tags: ['Character Comedy', 'Transformation', 'Storytelling'],
    link: '#'
  }
];

const ComedyPage: React.FC = () => {
  return (
    <div>
      <motion.div 
        className="text-center max-w-3xl mx-auto mb-12"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-4xl font-bold mb-6">RANDM Comedy</h1>
        <p className="text-xl text-gray-600">
          Our comedic experiments across different formats. From stand-up to sketch, improv to character work,
          written pieces to live performances. Finding humor in the unexpected.
        </p>
      </motion.div>
      
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {comedyProjects.map((project, index) => (
          <motion.div
            key={project.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <ProjectCard {...project} />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ComedyPage; 